export { default } from './FlagText';
